export const MASTER_DATABASE_COLUMNS = [
  { title: "S.NO.", key: "serial", width: "w-16" },
  { title: "CANDIDATE STATUS", key: "status" },
  { title: "POINT OF HIRE", key: "point_of_hire" },
  { title: "ARRIVAL SECTOR", key: "sector_Name" },
  { title: "QUOTATION TYPE", key: "quotation_type" },
  { title: "EMPLOYEE ID", key: "candidate_id" },
  { title: "NEW EMPLOYEE ID", key: "NewEmployeeID" },
  { title: "NATIONALITY", key: "nationality_name" },
  { title: "RELIGION", key: "religion" },
  { title: "EMPLOYEE NAME", key: "name" },
  { title: "PASSPORT NO", key: "passport_number" },
  { title: "ACTUAL PROFESSION", key: "actual_profession" },
  { title: "D.O.B", key: "dob" },
  { title: "AGE", key: "age" },
  { title: "BASIC SALARY", key: "basic" },
  { title: "FOOD ALLOWANCE", key: "food" },
  { title: "FIXED OT", key: "fixed_ot" },
  { title: "HRA", key: "hra" },
  { title: "TRAVEL ALLOWANCE", key: "travel_allowance" },
  { title: "MOBILE ALLOWANCE", key: "mobile_allowance" },
  { title: "AIR TICKET ALLOWANCE", key: "air_ticket_allowance" },
  { title: "ADDITIONAL OT", key: "additional_ot" },
  { title: "OTHER ALLOWANCE", key: "other_allowance" },
  { title: "DUTY HOURS", key: "duty_hours" },
  { title: "FIXED OT HOURS", key: "fixed_ot_hours" },
  { title: "DURATION OF CONTRACT", key: "duration_of_contract" },
  { title: "PROBATION PERIOD", key: "probation_period" },
  { title: "PASSPORT ISSUE DATE", key: "passport_issue_date" },
  { title: "PASSPORT EXPIRY DATE", key: "passport_expiry_date" },
  { title: "EMERGENCY CONTACT NAME", key: "emergency_contact_person_in_home_country" },
  { title: "EMERGENCY CONTACT NUMBER", key: "emergency_contact_number_in_home_country" },
  { title: "COVID VACCINE", key: "covid_vaccine_action" },
  { title: "BLOOD GROUP", key: "blood_group_action" },
  { title: "SPONSOR ID", key: "Initial_Sponsor_Id" },
  { title: "CURRENT SPONSOR NAME", key: "Initial_Sponsor_Name" },
  { title: "IQAMA PROFESSION", key: "visa_profession_id" },
  { title: "VISA BLOCK NUMBER", key: "visa_block_number" },
  { title: "VISA REFERENCE NUMBER", key: "visa_reference_number" },
  { title: "VISA STAMPING DATE", key: "visa_stamping_date" },
  { title: "Arrival DATE", key: "arrival_date" },
];

export const MASTER_DATABASE_SEARCHABLE_FIELDS = [
  "status",
  "candidate_id",
  "NewEmployeeID",
  "name",
  "passport_number",
  "nationality_name",
  "border_number",
];

export const MASTER_DATABASE_CONFIG = {
  API_ENDPOINT: "/arrivedCandidates",
  DOWNLOAD_ENDPOINT: "/mobilization/generateemployeeReport",
  DEFAULT_PAGE_SIZE: 50,
  PAGE_SIZE_OPTIONS: [50, 100, 200, 500],
  SEARCH_PLACEHOLDER: "Search by ID, Name, Passport, or Border Number...",
  DOWNLOAD_FILENAME: "OPS2_Master_Database",
  NO_DATA_MESSAGE: "No arrived candidates found.",
  DEBOUNCE_MS: 500,
};
